/* global nubeeGlobals */

// Refactored nubeeGFDropzone.js
export function nubeeGFDropzone( formId, newDropzoneId ) {
	const uploadedFiles = new Map();

	// Check if the dropzone already exists
	let existingDropzone = document.querySelector(`#gform_${formId} .gform_fileupload_multifile`);
	if( ! existingDropzone ) {
		console.error(`Dropzone for form ${formId} not found.`);
		return;
	}

	// Create the dropzone element
	let newDropzone = document.createElement('div');
	newDropzone.id = newDropzoneId;
	newDropzone.classList.add('dropzone');

	// Add instructions
	let instructions = document.createElement('div');
	instructions.classList.add('instructions');

	let instructionsLabel = document.createElement('span');
	instructionsLabel.classList.add('label');
	instructionsLabel.innerText = nubeeGlobals.i18n.dropzone.dropzoneLabel;

	let instructionsButton = document.createElement('span');
	instructionsButton.classList.add('fake-button');
	instructionsButton.innerText = nubeeGlobals.i18n.dropzone.button;

	instructions.appendChild(instructionsLabel);
	instructions.appendChild(instructionsButton);
	newDropzone.appendChild(instructions);

	// Add file list
	let fileList = document.createElement('ul');
	fileList.classList.add('files-list');
	newDropzone.appendChild(fileList);

	// Add progress bar
	let progressBar = document.createElement('div');
	progressBar.classList.add('progress-bar');
	newDropzone.appendChild(progressBar);

	// Replace existing dropzone
	existingDropzone.parentNode.replaceChild(newDropzone, existingDropzone);

	// Handle file input click
	instructions.addEventListener('click', () => {
		let fileInput = document.createElement('input');
		fileInput.type = 'file';
		fileInput.multiple = true;
		fileInput.style.display = 'none';
		fileInput.addEventListener('change', (e) => handleFiles(e.target.files));
		document.body.appendChild(fileInput);
		fileInput.click();
		document.body.removeChild(fileInput);
	});

	// Handle drag and drop
	newDropzone.addEventListener('dragover', (e) => {
		e.preventDefault();
		newDropzone.classList.add('drag-over');
	});

	newDropzone.addEventListener('dragleave', () => {
		newDropzone.classList.remove('drag-over');
	});

	newDropzone.addEventListener('drop', (e) => {
		e.preventDefault();
		newDropzone.classList.remove('drag-over');
		handleFiles(e.dataTransfer.files);
	});

	// Handle file processing
	function handleFiles(files) {
		Array.from(files).forEach(file => {
			if(!uploadedFiles.has(file.name)) {
				uploadedFiles.set(file.name, file);

				// Add to file list
				let listItem = document.createElement('li');
				listItem.classList.add('file');

				let fileName = document.createElement('span');
				fileName.classList.add('file-name');
				fileName.innerText = file.name;

				let removeButton = document.createElement('button');
				removeButton.classList.add('file-remove-btn');
				removeButton.innerText = nubeeGlobals.i18n.dropzone.remove;
				removeButton.addEventListener('click', () => {
					uploadedFiles.delete(file.name);
					fileList.removeChild(listItem);
				});

				listItem.appendChild(fileName);
				listItem.appendChild(removeButton);
				fileList.appendChild(listItem);
			}
		});

		uploadFiles();
	}

	// Handle file uploads
	function uploadFiles() {
		let formData = new FormData();
		uploadedFiles.forEach((file, index) => {
			formData.append('file' + index, file);
		});

		formData.append('upload_nonce', nubeeGlobals.dropzoneNonce);
		formData.append('form_id', formId);

		let xhr = new XMLHttpRequest();
		xhr.open('POST', nubeeGlobals.uploadUrl, true);

		xhr.upload.onprogress = (event) => {
			if(event.lengthComputable) {
				let percentComplete = (event.loaded / event.total) * 100;
				progressBar.style.width = percentComplete + '%';
			}
		};

		xhr.onload = () => {
			if(xhr.status === 200) {
				console.log('Upload complete!');
				progressBar.style.opacity = 0;
				newDropzone.style.cursor = 'auto';
			} else {
				console.error('Upload failed.');
			}
		};

		xhr.send(formData);
	}
}